
import { Skeleton, Stack } from "@chakra-ui/react";
import React from "react";

const ChatLoading = () => {
  return (
    <Stack>
      {Array(16)
        .fill()
        .map((_, index) => (
          <Skeleton key={index} height="45px" />
        ))}
    </Stack>
  );
};

export default ChatLoading;
